import React from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';

/**
 * Component for selecting a client
 * @param {Object} props - Component props
 * @param {string} props.selectedClient - Currently selected client
 * @param {Function} props.handleClientChange - Handler for client selection change
 * @param {boolean} props.disabled - Whether the selector is disabled
 * @param {Array} props.clients - List of available client keys
 */
const ClientSelector = ({ selectedClient, handleClientChange, disabled, clients = [] }) => {
  return (
    <FormControl className="client-select" disabled={disabled}>
      <Select
        value={selectedClient}
        onChange={handleClientChange}
        displayEmpty
        className="select-box"
        // renderValue={(selected) => {
        //   if (selected === "") {
        //     return <em>Select Client</em>;
        //   }
        //   return selected;
        // }}
      >
        <MenuItem value="" disabled>
          <em>Select Client</em>
        </MenuItem>
        {clients.map((client) => (
          <MenuItem key={client.client_id} value={client.client_id}>
            {client.company_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ClientSelector; 